import { axiosClientv1 } from "./apiClient";
import { ApiResponse, RouteCheckIn, RouteCheckInFilter } from "../Types";

export const GetRouteCheckIns = async (
  params: RouteCheckInFilter & { page?: number; limit?: number },
): Promise<ApiResponse<{ check_ins: RouteCheckIn[]; total: number }>> => {
  try {
    const response = await axiosClientv1.get(`/route-check-ins`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load route check-in records.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateRouteCheckIn = async (payload: {
  route_id?: string;
  order_id?: string;
  latitude: number;
  longitude: number;
  action?: string;
  notes?: string;
}): Promise<ApiResponse<RouteCheckIn>> => {
  try {
    const response = await axiosClientv1.post(
      `/route-check-ins/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to submit route location check-in.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
